import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-warehouse',
  templateUrl: './data-warehouse.component.html',
  styleUrls: ['./data-warehouse.component.sass']
})
export class DataWarehouseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
